export default __webpack_public_path__ + "static/media/DMCA_Logo.426eda45.png";